/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { ConvivaSession } from './ConvivaSession';
import { createConvivaSession } from './ConvivaSessionFactory';
import { AdTechnology } from './internal/AdTechnology';
import { ConvivaInitializationData } from './model/ConvivaInitializationData';
import { ConvivaDeviceMetadata, ConvivaMetadata, ConvivaPlayerInfo } from './internal/conviva-core-sdk';
import { AdMetadata } from './model/AdMetadata';

const version = '__buildVersion__';

export {
  AdMetadata,
  AdTechnology,
  ConvivaDeviceMetadata,
  ConvivaMetadata,
  ConvivaPlayerInfo,
  ConvivaInitializationData,
  ConvivaSession,
  createConvivaSession,
  version,
};
